// Browser-specific utility functions
export { convertCookieToKey } from './cookie';
export { parseRecentlyViewedProductIds } from './recentlyViewed';
